/**
 * Figma Side Menu v5 icon mapping (87715:35675 / 87725:36389).
 * Keys = Figma layer `data-name`; values = OspIcons name (font or richColor SVG).
 *
 * Missions layer `aura` (87715:35710) is a stroke star — use `aura_solid` SVG,
 * not the font glyph `aura`.
 */
export const FIGMA_SIDE_MENU_ICON_MAP = {
  invest: "finance",
  explore: "explore",
  "time-five": "time-five",
  goal: "goal-custom",
  "dollar-bag": "dollar-bag",
  news: "news",
  "grid-alt": "grid-alt",
  portfolio: "portfolio",
  aura: "aura_solid",
  "dollar-circle": "dollar-circle",
} as const;

export type FigmaSideMenuIconLayer = keyof typeof FIGMA_SIDE_MENU_ICON_MAP;

/** Nav id → Figma icon layer */
export const SIDE_MENU_NAV_FIGMA_LAYER: Record<string, FigmaSideMenuIconLayer> =
  {
    invest: "invest",
    brief: "explore",
    plan: "dollar-bag",
    track: "grid-alt",
    desk: "time-five",
    goal: "goal",
    news: "news",
    discover: "grid-alt",
    portfolio: "portfolio",
    missions: "aura",
    subscriptions: "dollar-circle",
  };

export function resolveSideMenuOspIcon(navId: string): string {
  const layer = SIDE_MENU_NAV_FIGMA_LAYER[navId];
  if (!layer) {
    return "explore";
  }
  return FIGMA_SIDE_MENU_ICON_MAP[layer];
}
